import { IndexRange } from 'components/MediaInput/MultimediaPlugin/types';

export type MultiMediaFetchItemsType = (opts?: IndexRange) => Promise<void>;
export enum ArticleFormat {
  Rich = 'Rich',
  Slideshow = 'Slideshow',
  Video = 'Video',
}
